import React, { useCallback, useRef, useState } from 'react';
import { useField, useFormikContext } from 'formik';
import { Box, capitalize } from '@mui/material';
import RadioGroup from '@mui/material/RadioGroup';
import { Radio, InputField } from '../../atoms';
import { StyledFormControlLabel } from '../../forms/_common/styled';

const RADIO_VALUE = {
  update: 'update',
  create: 'create',
};

const NameField = () => {
  const { isSubmitting, resetForm } = useFormikContext();
  const [, { initialValue: idInitialValue }, idHelpers] = useField('id');
  const [nameField, { initialValue: nameInitialValue, error, touched }, nameHelpers] = useField('name');
  const [radio, setRadio] = useState(() => (idInitialValue ? RADIO_VALUE.update : RADIO_VALUE.create));
  const nameHelpersRef = useRef(nameHelpers);
  const idHelpersRef = useRef(idHelpers);

  const handleChange = useCallback(
    ({ target: { value } }) => {
      setRadio(value);

      if (value === RADIO_VALUE.create) {
        nameHelpersRef.current.setValue('');
        idHelpersRef.current.setValue('');

        return;
      }

      if (value === RADIO_VALUE.update) {
        resetForm({
          values: {
            name: nameInitialValue,
            id: idInitialValue,
          },
        });
      }
    },
    [idInitialValue, nameInitialValue, resetForm]
  );

  const isTextFieldDisabled = radio === RADIO_VALUE.update || isSubmitting;

  return (
    <Box>
      <RadioGroup aria-label="name-action" name="name-action" value={radio} onChange={handleChange}>
        <StyledFormControlLabel
          value={RADIO_VALUE.update}
          control={<Radio color="primary" />}
          label={
            <>
              <span>Save changes to</span>
              &nbsp;
              <Box component="b" color="#232629">
                {capitalize(nameInitialValue)}
              </Box>
            </>
          }
          disabled={isSubmitting || !idInitialValue}
          textTransform="none"
        />

        <StyledFormControlLabel
          value={RADIO_VALUE.create}
          control={<Radio color="primary" />}
          label="Create new view"
          disabled={isSubmitting}
          textTransform="none"
        />
      </RadioGroup>

      {!isTextFieldDisabled && (
        <Box m="8px 0 0 25px">
          <InputField
            variant="outlined"
            color="primary"
            placeholder="Enter new view name"
            disabled={isTextFieldDisabled}
            fullWidth
            error={touched && Boolean(error)}
            helperText={touched && error}
            {...nameField}
          />
        </Box>
      )}
    </Box>
  );
};

export default NameField;
